/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WeatherSunIcon16Light } from './WeatherSunIcon16Light';
import { WeatherSunIcon16Regular } from './WeatherSunIcon16Regular';
import { WeatherSunIcon16Solid } from './WeatherSunIcon16Solid';
import { WeatherSunIcon20Light } from './WeatherSunIcon20Light';
import { WeatherSunIcon20Regular } from './WeatherSunIcon20Regular';
import { WeatherSunIcon20Solid } from './WeatherSunIcon20Solid';
import { WeatherSunIcon24Regular } from './WeatherSunIcon24Regular';
import { WeatherSunIcon24Solid } from './WeatherSunIcon24Solid';
import { WeatherSunIcon32Regular } from './WeatherSunIcon32Regular';
import { WeatherSunIcon64Regular } from './WeatherSunIcon64Regular';
var sizes = {
    16: {
        light: WeatherSunIcon16Light,
        regular: WeatherSunIcon16Regular,
        solid: WeatherSunIcon16Solid,
    },
    20: {
        light: WeatherSunIcon20Light,
        regular: WeatherSunIcon20Regular,
        solid: WeatherSunIcon20Solid,
    },
    24: {
        regular: WeatherSunIcon24Regular,
        solid: WeatherSunIcon24Solid,
    },
    32: {
        regular: WeatherSunIcon32Regular,
    },
    64: {
        regular: WeatherSunIcon64Regular,
    },
};
export var WeatherSunIcon = forwardRef('WeatherSunIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
